export default __webpack_public_path__ + "static/media/no-online-test.4b4e3ec5.svg";